import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const ReservationSummaryWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  .cancellation_policy {
    font-weight: 700;
    color: ${colors.text.kleinBlue};
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
  @media only screen and ${sizes.max991} {
    gap: 2vw;
    border-radius: 8px !important;
    border: 1px solid var(--Gray-5, #E0E0E0) !important;
    background: #FAFAFA !important;
    padding-left: 1.5vw !important;
    padding-right: 1.5vw !important;
  }
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(27)}
  line-height: 120%;
  color: ${colors.text.chambray};
  margin-bottom: 24px;
  @media only screen and ${sizes.max991} {
    margin-bottom: 4.8vw;    
  }
`;

export const Subtitle = styled.span`
  font-style: normal;
  font-weight: 700;
  ${fontSize(17)}
  line-height: 140%;
  text-transform: uppercase;
  color: ${colors.text.ebony};
`;

export const Value = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 400;
  ${fontSize(16)}
  line-height: 120%;
  color: ${colors.text.mineShaft};
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Pair = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const RowTitle = styled.span`
  min-width: 120px;
  font-style: normal;
  font-weight: ${props => props.bold ? 700 : 400};
  ${fontSize(16)}
  line-height: 140%;
  color: ${colors.text.emperor};
  i {
    display: flex;
    max-width: 360px;
    font-size: ${fontSize(13)};
  }
`;

export const RowValue = styled.span`
  font-style: normal;
  font-weight: ${props => props.bold ? 700 : 400};
  ${fontSize(16)}
  line-height: 140%;
  color: ${props => props.green ? colors.text.salem : (props.red ? colors.text.burntSienna : colors.text.ebony)};
`;
